module.exports = __webpack_public_path__ + "static/img/50.03381dc.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_right_icon/50.png
// module id = oZYR
// module chunks = 1